export default "__VITE_ASSET__Dttb5LZc__"